import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';
import specificationsStyles from './specificationsStyles';
import IndicativeNumber from '../../../../../../gqlCommon/components/indicativeNumber/IndicativeNumber';
import useScrollToSection from '../../../../../hooks/navigation/useScrollToSection';
import ShowIfTranslationExists from '../../../../../../common/components/ShowIfTranslationExists';

export interface ISpecificationsProps {
  specifications?: string[];
}

const Specifications: FunctionComponent<ISpecificationsProps> = ({ specifications }) => {
  const styles = specificationsStyles();
  const { scrollToDisclaimer } = useScrollToSection();

  if (!specifications?.length) {
    return null;
  }

  return (
    <Box className={styles.container} data-test="customise:specificationsContent">
      <Typography className={styles.title} data-test="customise:specificationsTitle">
        <Translation id="trans__configurator__customise_page_variant_section__specification_subtitle" />
        <ShowIfTranslationExists translationKey="trans__configurator__indicative_numbers__specifications">
          <IndicativeNumber
            dataTest="specifications_title"
            displayNumber={<Translation id="trans__configurator__indicative_numbers__specifications" />}
            onClick={scrollToDisclaimer}
          />
        </ShowIfTranslationExists>
      </Typography>
      {specifications.map(spec => (
        <Typography
          key={spec}
          component="p"
          variant="body1"
          className={styles.description}
          data-test={`customise:specification:${spec}`}
        >
          {spec}
        </Typography>
      ))}
    </Box>
  );
};

export default Specifications;
